import Request from './request';
import consts from "@/consts.js";
import i18n from '@/i18n'
import store from '@/store.js'
import snackbar from '@/plugins/snackbar'

async function fetch(data) {
    return Request('get', "api/stock-materials/index", data);
}

async function fetchAll(data) {
    if (!data) data = {};
    return Request('get', "api/stock-materials/index", Object.assign({},data,{
        itemsPerPage: consts.limitAll,
        limit: consts.limitAll,
    }));
}

async function stockEdit(data) {
    if (!data) data = {};
    return Request('post', "api/stock-materials/edit", data);
}

// 导出当前库存报表
async function exports(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-materials/export', data)
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

// 获取商品分类
async function fetchAllCategories(data) {
    if (!data) data = {};
    return Request('get', "api/stock-materials/get-categories", Object.assign({},data,{
        itemsPerPage: consts.limitAll,
        limit: consts.limitAll,
    }));
}  

export default {
    fetch,
    fetchAll,
    stockEdit,
    exports,
    fetchAllCategories
};